export default function Img(props) {
    let img = require("../images/image-product-" + props.number + ".jpg");
    return <img src={img} alt={"product img" + props.number} />;
}
